import { EntityApiKeysRepository } from "@entity-api-keys/data/repositories/entity-api-keys.repository";
import {
    PublicApiUsageStats,
    PublicApiUsageStatsByApiKeyRow,
} from "@entity-api-keys/domain/models/public-api-usage-stats.model";
import { inject, injectable } from "inversify";

const emptyStats = (period: string): PublicApiUsageStats => ({
    period,
    from: "",
    to: "",
    totals: { requests: 0, errors: 0 },
    by_api_key: [] as PublicApiUsageStatsByApiKeyRow[],
});

@injectable()
export class GetPublicApiUsageStatsUseCase {
    constructor(
        @inject(EntityApiKeysRepository)
        private readonly repository: EntityApiKeysRepository,
    ) {}

    async execute(period: string): Promise<PublicApiUsageStats> {
        const result = await this.repository.getUsageStats(period);

        return result.fold(
            () => emptyStats(period),
            (stats) => stats,
        );
    }
}
